import { createContext } from "react";

import type { TabsOverrideContextValue } from "./types";

export const TabsOverrideContext =
  createContext<TabsOverrideContextValue | null>(null);
TabsOverrideContext.displayName = "TabsOverrideContext";
